








































































import Component from "vue-class-component";
import { BFormDatepicker } from "bootstrap-vue";
import { BaseRootPageComponent } from "@/components/BaseRootPageComponent";

import LoadingIndicator from "@/components/LoadingIndicator.vue";
import CoreAPI, { BASE_URL } from "@/utils/core-api";
import * as modals from "@/utils/modals";
import { getToken } from "@/utils/auth";

@Component({
  components: {
    LoadingIndicator,
    BFormDatepicker
  }
})
export default class Events extends BaseRootPageComponent {
  loading = true;
  from: Date;
  to: Date;
  events: any[] = [];

  constructor() {
    super();

    // Get the date without the timestamp
    const to = new Date();
    this.to = new Date(to.getFullYear(), to.getMonth(), to.getDate());

    // Get the date 2 weeks before without the timestamp
    this.from = new Date(this.to);
    this.from.setDate(this.from.getDate() - 14);
  }

  get downloadLink() {
    const range = this.getDateRange();

    return `${BASE_URL}/events?format=xlsx&from=${range.from}&to=${range.to}&token=${getToken()}`;
  }

  async created() {
    this.setTitle("Events");
    await this.fetchEvents();
  }

  async fetchEvents() {
    this.loading = true;
    const range = this.getDateRange();

    try {
      this.events = await CoreAPI.getEvents(range.from, range.to);
    } catch (error) {
      this.events = [];

      if ((error as any).isNetworkError) {
        await modals.showLostConnectionModal(this.$bvModal);
      } else {
        await modals.showUnexpectedErrorModal(this.$bvModal);
      }
    } finally {
      this.loading = false;
    }
  }

  getDateRange() {
    // Set the to date to the end of the day (by getting the next day and subtracting a millisecond)
    const to = new Date(this.to);
    to.setDate(to.getDate() + 1);
    to.setMilliseconds(-1);

    return { from: this.from.toISOString(), to: to.toISOString() };
  }
}
